export default function PHP_getservbyname() {
  return (
    <div>
      <h1>PHP_getservbyname</h1>
    </div>
  );
}
